<template>
  <div v-if="release" :class="large ? 'text-center' : 'app-qr-corner'">

    <!-- Крупный вид: страница входа -->
    <template v-if="large">
      <h5 class="mb-1">Приложение для телефона</h5>
      <p class="text-muted mb-1">
        Наведите камеру телефона на код — скачается приложение «{{ productTitle }}»
        для измерений на путях.
      </p>
      <img v-if="qr" :src="qr" alt="QR-код для скачивания приложения" class="app-qr-image" />
      <p class="mb-0 mt-1">
        <strong>Версия {{ release.version }}</strong>
        <span class="text-muted"> · сборка {{ release.versionCode }} · {{ sizeMb }} МБ</span>
      </p>
      <p class="text-muted small mb-0">
        Обновлено {{ publishedAt }}. Ссылка: <span class="text-nowrap">{{ release.url }}</span>
      </p>
    </template>

    <!-- Компактный вид: угол остальных страниц -->
    <template v-else>
      <b-button
        v-b-tooltip.hover.right="'Скачать приложение ' + productTitle + ' · версия ' + release.version"
        variant="flat-primary"
        class="btn-icon app-qr-toggle"
        size="sm"
        @click="modal = true"
      >
        <feather-icon icon="SmartphoneIcon" size="18" />
      </b-button>

      <b-modal v-model="modal" :title="'Приложение ' + productTitle" hide-footer centered>
        <div class="text-center">
          <p class="text-muted mb-1">
            Наведите камеру телефона на код — скачается приложение для измерений.
          </p>
          <img v-if="qr" :src="qr" alt="QR-код для скачивания приложения" class="app-qr-image" />
          <p class="mb-0 mt-1">
            <strong>Версия {{ release.version }}</strong>
            <span class="text-muted"> · сборка {{ release.versionCode }} · {{ sizeMb }} МБ</span>
          </p>
          <p class="text-muted small mb-1">Обновлено {{ publishedAt }}</p>
          <b-button variant="primary" size="sm" :href="release.url" target="_blank">
            Скачать файлом
          </b-button>
        </div>
      </b-modal>
    </template>

  </div>
</template>

<script>
import { BButton, BModal, VBTooltip } from 'bootstrap-vue'
import QRCode from 'qrcode'
import { $themeConfig } from '@themeConfig'

export default {
  name: 'AppDownloadQr',
  components: { BButton, BModal },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    // на странице входа код крупный с пояснением, на остальных — кнопка в углу
    large: { type: Boolean, default: false },
  },
  data() {
    return { release: null, qr: null, modal: false }
  },
  computed: {
    productTitle() {
      // Раньше бралось из VUE_APP_PRODUCT — сборочная переменная нигде не
      // задавалась (нет .env ни в одном из репозиториев), и оба продукта
      // показывали «МИГ» из зашитого запасного значения. themeConfig.js уже
      // содержит верное название на каждый продукт — берём его напрямую.
      return $themeConfig.app.appName.toUpperCase()
    },
    sizeMb() {
      return this.release ? (this.release.size / 1048576).toFixed(1) : ''
    },
    publishedAt() {
      if (!this.release || !this.release.published) return ''
      return new Date(this.release.published).toLocaleDateString('ru-RU', {
        day: '2-digit', month: 'long', year: 'numeric',
      })
    },
  },
  async created() {
    try {
      // Запрос идёт в обход общего клиента: тот подставляет токен, и с истёкшим
      // ключом сервер отвечает 401 ещё до проверки прав. Сведения о сборке открыты
      // для всех — они нужны и на странице входа, где токена нет вовсе.
      const response = await fetch(`${process.env.VUE_APP_API_URL}app-release/`)
      if (!response.ok) throw new Error(`сервер ответил ${response.status}`)
      const data = await response.json()
      this.release = data
      this.qr = await QRCode.toDataURL(data.url, { width: 220, margin: 1 })
    } catch (e) {
      // Раздача сборок может быть ещё не наполнена — тогда просто ничего не показываем
      this.release = null
    }
  },
}
</script>

<style scoped>
.app-qr-image {
  width: 200px;
  height: 200px;
  image-rendering: pixelated;
}
/* Кнопка в левом нижнем углу рабочей области. Отступ слева считается от бокового
   меню: при позиции от края экрана кнопка оказывается под навигацией и не видна.
   z-index выше меню — иначе её перекрывает даже при правильном отступе. */
.app-qr-corner {
  position: fixed;
  left: 12px;
  bottom: 12px;
  z-index: 1041;
}
@media (min-width: 992px) {
  .app-qr-corner {
    left: 272px;
  }
  /* Свёрнутое меню занимает меньше места */
  .menu-collapsed .app-qr-corner {
    left: 92px;
  }
}
.app-qr-toggle {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 50%;
}
</style>
